import { withStyles } from '@/components/Buttons/Core/withStyles';
import { BaseButton } from '@/components/Buttons/Core/BaseButton';

export const InputButton = withStyles(BaseButton, {
    light: 'white',
    dark: 'rgba(128,128,128,.25)',
    style: {
        borderWidth: 1,
        borderColor: 'rgba(0,0,0,.25)',
    },
    textStyle: {
        light: 'black',
        dark: 'white',
        fontSize: 16,
        lineHeight: 16
    }
});
